module.exports = __webpack_public_path__ + "img/HBO.ae651b77.png";